export default __webpack_public_path__ + "static/media/arrow-down-light.c8b7c9e5.svg";